import { render, staticRenderFns } from "./pictureSettings.vue?vue&type=template&id=7c60a221&scoped=true&"
import script from "./pictureSettings.vue?vue&type=script&lang=js&"
export * from "./pictureSettings.vue?vue&type=script&lang=js&"
import style0 from "./pictureSettings.vue?vue&type=style&index=0&id=7c60a221&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c60a221",
  null
  
)

export default component.exports